/**
 * Initialize @cabaza/shared with web storage adapter
 * This file must be imported at app startup before using shared services
 */

import { setStorageAdapter } from '@cabaza/shared';

// Configure the storage adapter for web (localStorage)
setStorageAdapter({
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch {
      console.error('Failed to save to localStorage:', key);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      console.error('Failed to remove from localStorage:', key);
    }
  },
});
